import { Container, Heading, SubHeading } from './styles';

type EmptySearchStateProps = {
    description: string;
};

const EmptySearchState = ({ description }: EmptySearchStateProps) => (
    <Container gap={2} fullWidth direction="column" justify="center" align="center">
        <Heading>Nothing found</Heading>
        <SubHeading>{description}</SubHeading>
    </Container>
);
export default EmptySearchState;
